export default __webpack_public_path__ + "static/media/promo_01.c111cbbc.jpg";